import { usePage, Link } from "@inertiajs/react"
import { DebugWidget } from "@/components/DebugWidget"

interface PageLayoutProps {
  children: React.ReactNode
}

export function PageLayout({ children }: PageLayoutProps) {
  const { props } = usePage()
  const showDebug = Boolean((props as { debug_widget?: boolean })?.debug_widget)
  const currentUser = (props as { current_user?: { id?: number } })?.current_user
  const isLoggedIn = Boolean(currentUser?.id)

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-[#f5f6f7] via-[#cfd5dc] to-[#696667]/30">
      {showDebug && <DebugWidget />}
      <main className="flex-1 flex items-center justify-center p-4 overflow-y-auto md:overflow-visible">
        {children}
      </main>

      <footer className="py-4 px-4 border-t border-border/30">
        <div className="max-w-6xl mx-auto relative">
          {/* Texto centralizado */}
          <p className="text-sm text-muted-foreground text-center">
            ◈ Método desenvolvido por Rafaela Ferreira e Maria Cláudia Lopes — 25Segundos ◈
          </p>
          {/* Links à direita */}
          <div className="flex items-center justify-center gap-4 text-sm mt-2 sm:mt-0 sm:absolute sm:right-0 sm:top-1/2 sm:-translate-y-1/2">
            {isLoggedIn && (
              <Link
                href="/minha-conta"
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Minha Conta
              </Link>
            )}
            <Link
              href="/politica-de-privacidade"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacidade
            </Link>
            <Link
              href="/termos-de-uso"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Termos de Uso
            </Link>
          </div>
        </div>
      </footer>
    </div>
  )
}
